import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, AbstractControl } from '@angular/forms';
import { CarrierService } from '@app/modules/carrier/carrier.service';

@Component({
  selector: 'app-origin-destination-radius',
  templateUrl: './origin-destination-radius.component.html',
  styles: [
  ]
})
export class OriginDestinationRadiusComponent {
  //#region  Variables
  radiusSearchForm!: FormGroup;
  radiusList: any[] = [];
  @Input() defaultRadius!: number;
  @Input() defaultDestRadius!: number;
  @Input() hideOriginRadius = false;
  @Input() hideDestinationRadius = false;
  @Output() radius = new EventEmitter<any>();
  //#endregion

  //#region Constructor
  /**
   *Constructor for Radius search Component.
   */
  constructor(
    private readonly fb: FormBuilder,
    private readonly carrierService: CarrierService,
  ) {
  }
  //#endregion

  //#region  NG Methods
  /**
   * NG OnInit Method
   */
  ngOnInit() {
    this.initRadiusSearchForm();
    this.getRadiusSelectList();
  }
  //#endregion

  //#region Methods
  /**
   * Initialize Radius Search Form
   */
  initRadiusSearchForm() {
    this.radiusSearchForm = this.fb.group({
      originRadius: new FormControl(null),
      destinationRadius: new FormControl(null)
    });
  }

  /**
   * Get Abstract control method
   */
  getControl(control: string): AbstractControl {
    return this.radiusSearchForm.controls[control];
  }

  /**
   * Get Radius SelectList
   */
  getRadiusSelectList(): void {
    this.carrierService.getRadiusSelectList().subscribe((response) => {
      if (response) {
        this.radiusList = response.data;
        if (this.defaultRadius) {
          const radiusObj = this.radiusList.find(a => a.loadRadiusValue == this.defaultRadius);
          if (radiusObj) {
            this.radiusSearchForm.controls['originRadius'].setValue(radiusObj.loadRadiusId);
          }
        }
        if (this.defaultDestRadius) {
          const radiusObj = this.radiusList.find(a => a.loadRadiusValue == this.defaultDestRadius);
          if (radiusObj) {
            this.radiusSearchForm.controls['destinationRadius'].setValue(radiusObj.loadRadiusId);
          }
        }
      }
    });
  }

  /**
   * On search button click method
   */
  onSearchClick() {
    const radius = this.radiusSearchForm.getRawValue();
    if (radius?.originRadius) {
      const originRadius = this.radiusList.find(a => a.loadRadiusId == radius.originRadius);
      if (originRadius)
        radius.originRadius = originRadius.loadRadiusValue;
    }
    if (radius?.destinationRadius) {
      const destinationRadius = this.radiusList.find(a => a.loadRadiusId == radius.destinationRadius);
      if (destinationRadius)
        radius.destinationRadius = destinationRadius.loadRadiusValue;
    }
    this.radius.emit(radius);
  }

  /**
   * On clear filter click method
   */
  clear() {
    this.radiusSearchForm.controls['originRadius'].setValue(null);
    this.radiusSearchForm.controls['destinationRadius'].setValue(null);
    this.radius.emit(null);
  }
  //#endregion
}
